import { Injectable, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { AuthErrorHandler } from '@cigna/shared/angular/auth-data-access';
import { AuthError } from '@cigna/shared/angular/auth/oidc-util';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { FeatureTogglesFacade } from '@cigna/shared/angular/features-feature';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CignaForBrokersAuthenticationService implements AuthErrorHandler {
  isOktaLoginEnabled$ = this._featuresToggleFacade.featuresEnabled([
    'isOktaLoginEnabled',
  ]);

  constructor(
    private _featuresToggleFacade: FeatureTogglesFacade,
    @Optional() private _router?: Router,
  ) {}

  onError(error: AuthError) {
    if (error.isLoginRequired()) {
      this.redirectToLogin();
      return;
    }
    this.showMaintenance();
  }
  private redirectToLogin(): void {
    this.isOktaLoginEnabled$
      .pipe(take(1))
      .subscribe((isOktaLoginEnabled: boolean) => {
        if (isOktaLoginEnabled) {
          this._router?.navigate(['public/login']);
        } else {
          this._router?.navigate(['web/login']);
        }
        // this.isOktaLoginEnabled = isOktaLoginEnabled;
      });
  }
  private showMaintenance(): void {
    // Redirect to generic unavailable page
    this._router?.navigate(
      ['/unavailable'],
      // Don't update URL so refreshing the browser retries the existing page
      { skipLocationChange: true },
    );
  }
}
